import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/_users'
)({
  component: () => <Outlet />
})
